import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { TypeCountdownWithoutUnresolvableLinksResponse } from 'contentful-types'
import { CountdownProps } from './Countdown'
import Countdown from './Countdown'

const contentfulAlignmentMapper: Record<TypeCountdownWithoutUnresolvableLinksResponse['fields']['alignment'], string> =
  {
    Center: 'center',
    Left: 'flex-start',
    Right: 'flex-end',
  }

const ContentfulCountdown = withContentful<TypeCountdownWithoutUnresolvableLinksResponse['fields'], CountdownProps>(
  Countdown,
  {
    alignment: (props) => contentfulAlignmentMapper[props.fields.alignment],
  }
)

export default ContentfulCountdown
